<!-- Modals -->
<ui-dialog
    [open]="currentlyOpenDialog === 'REQUEST_CUSTOM_DEDUCTION'"
    [form]="createForm.form"
    (primaryButtonPressed)="onCreate(createForm.customDeductionType, createForm)"
    primaryButtonLabel="save"
    (secondaryButtonPressed)="createForm.reset(); onCancel(createForm)"
    secondaryButtonLabel="cancel"
    (closing)="onCancel(createForm)"
    size="small"
    header="payroll.deductions.requestDeduction"
>
    <app-form-request-custom-deduction-type #createForm></app-form-request-custom-deduction-type>
</ui-dialog>

<ui-dialog
    #deleteConfirmationDialog
    header="{{ 'payroll.deductions.deleteDeduction' | translate }}"
    confirmationDialog
    (closing)="this.deleteConfirmationDialog.open = false"
    (primaryButtonPressed)="this.deleteConfirmationDialog.open = false; onDelete(currentDeduction)"
>
    <p>{{ 'payroll.deductions.areYouSureYouWishToDeleteThisDeduction' | translate }}</p>
</ui-dialog>

<!-- Page Content -->
<div class="ui basic segment" [class.loading]="isLoading">
    <app-header title="{{ 'payroll.deductions.deductions' | translate }}" [menuService]="payrollModuleMenuService">
        <div class="buttons">
            <ui-button type="ghost" (click)="currentlyOpenDialog = 'REQUEST_CUSTOM_DEDUCTION'">{{
                'payroll.deductions.requestCustomDeduction' | translate
            }}</ui-button>
            <ui-button *ngIf="!route.snapshot.data.isPayrollPending" type="primary" url="create">
                <mat-icon svgIcon="plus"></mat-icon>{{ 'payroll.deductions.createDeduction' | translate }}
            </ui-button>
        </div>
    </app-header>

    <!-- Disabled Banner -->
    <ui-banner *ngIf="route.snapshot.data.isPayrollPending" class="margin-bottom-4" variant="warning">
        <p class="flag-content">{{ 'payroll.deductions.pendingPayrollNotice' | translate }}</p>
    </ui-banner>

    <app-table [table]="table" (menuItemSelected)="menuAction($event)">
        <div class="empty">
            <img style="max-width: 30%" src="/assets/illustrations/magnifying-glass.png" />
            <h2 class="ui centered header">{{ 'payroll.deductions.noDeductionsFound' | translate }}</h2>
        </div>
    </app-table>
</div>
